/* Shared */
import { NumberCell, StringCell } from 'application/Shared/Components/Cells';
import { Header } from 'application/Shared/Components/Table/Header';

export const popoverContentsColumns = [
    {
        accessorKey: 'name',
        cell: StringCell,
        enableColumnFilter: false,
        enableHiding: false,
        header: Header,
        id: 'entry',
        name: 'Common.entry',
        size: 150,
        testId: 'accounts'
    },
    {
        accessorKey: 'value',
        cell: NumberCell,
        enableColumnFilter: false,
        enableHiding: false,
        header: Header,
        id: 'value',
        name: 'Common.value',
        size: 100,
        testId: 'value'
    }
];
